import { createFileRoute } from '@tanstack/react-router';

import { AutomationPage } from '@/pages';

export const Route = createFileRoute('/(app)/utils/automation')({
  component: AutomationPage,
});
